// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q2/2022new_home/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

export { getBaseInfo, save, getNews };
